import { render } from "./popupBase.vue?vue&type=template&id=32e11351&scoped=true"
import script from "./popupBase.vue?vue&type=script&lang=js"
export * from "./popupBase.vue?vue&type=script&lang=js"

import "./popupBase.vue?vue&type=style&index=0&id=32e11351&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e11351"]])

export default __exports__